import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
// import { useLazyGetSpecificUserByIdQuery } from "../../services/users";
import { UserData } from "../../types/General";
import { ImageModal } from "../../components";
import Loader from "../../helpers/constants/Loader";
import { useLazyGetOrderDetailByIdQuery } from "../../services/order";
import useTranslation from "../../hooks/Translation";
const CustomerDetails = () => {
  const { _id } = useParams();
  const t = useTranslation();
  const [ByIdDetails, setByIdDetails] = useState<any>({});
  // const [fetchApi, { isLoading }] = useLazyGetSpecificUserByIdQuery();
  const [fetchApi] = useLazyGetOrderDetailByIdQuery();
  const [open, setOpen] = useState<boolean>(false);
  const [selectedImage, setSelectedImage] = useState<string>("");
  const handleClose = () => {
    setOpen(false);
  };

  const fetchDataById = async () => {
    try {
      const response = await fetchApi(_id).unwrap();
      if (response.status === 200) {
        const data = response.data;

        const extractedData = {
          name: data.user,
          dialCode: data.country_code,
          phoneNo: data.phone_no,
          orderStatus: data.order_status,
          subTotal: data.sub_total,
          deliveryFees: data.delivery_fees,
          totalCostPay: data.total_cost_pay,
          orderTrackId: data.order_track_id,
          address: data.address?.business_address || "-",
          city: data.address?.city || "-",
          pinCode: data.address?.pin_code || "-",
          product:
            data.product?.map((prod: any) => ({
              productName: prod.product_name_en,
              minQuantity: prod.min_quantity,
              pricePerUnit: prod.price_per_unit,
              buyQuantity: prod.buy_quantity,
              buyPrice: prod.buy_price,
              images:
                prod.product_image?.map((img: any) => img.media_url) || [],
            })) || [],
        };

        setByIdDetails(extractedData);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleOpenModal = (imageUrl: string) => {
    setSelectedImage(imageUrl);
    setOpen(true);
  };

  useEffect(() => {
    if (_id) {
      fetchDataById();
    }
  }, []);

  return (
    <Card className="cards">
      {/* <Loader isLoad={isLoading} /> */}
      <CardContent sx={{ p: 1 }}>
        <Grid container spacing={2} className="view_box">
          <Grid item lg={2} md={2} sm={6} xs={12}>
            <figure className="profile_img">
              <img
                src={
                  ByIdDetails?.image || `/static/images/user_placeholder.png`
                }
                alt=""
              />
              <div className="overlay">
                <img
                  onClick={() =>
                    handleOpenModal(
                      ByIdDetails?.image
                        ? ByIdDetails?.image
                        : "/static/images/cr7.png"
                    )
                  }
                  src="/static/images/visibility.png"
                  alt="img"
                />
              </div>
            </figure>
          </Grid>
          <Grid item xs={10} className="view_box_list">
            <Grid container spacing={3}>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <Box>
                  <Typography component="h5">{t.main.fullName}</Typography>
                  <Typography component="p">
                    {ByIdDetails?.name || "-"}
                  </Typography>
                </Box>
              </Grid>

              <Grid item lg={4} md={4} sm={6} xs={12}>
                <Box>
                  <Typography component="h5">{t.main.phoneNumber}</Typography>
                  <Typography component="p">
                    {ByIdDetails?.dialCode && ByIdDetails?.phoneNo
                      ? `${ByIdDetails.dialCode + " "}${ByIdDetails.phoneNo}`
                      : ""}
                  </Typography>
                </Box>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <Box>
                  <Typography component="h5">{t.main.email}</Typography>
                  <Typography component="p">
                    {" "}
                    {ByIdDetails?.email || "-"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <Box>
                  <Typography component="h5">{t.main.businessName}</Typography>
                  <Typography component="p">
                    {" "}
                    {ByIdDetails?.businessName || "-"}
                  </Typography>
                </Box>
              </Grid>

              <Grid item lg={4} md={4} sm={6} xs={12}>
                <Box>
                  <Typography component="h5">{t.main.regNo}</Typography>
                  <Typography component="p">
                    {ByIdDetails?.registrationNo || "-"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <Box>
                  <Typography component="h5">{t.main.industryType}</Typography>
                  <Typography component="p">
                    {ByIdDetails?.industryType || "-"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <Box>
                  <Typography component="h5">{t.main.city}</Typography>
                  <Typography component="p">
                    {ByIdDetails?.city || "-"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <Box>
                  <Typography component="h5">{t.main.pinCode}</Typography>
                  <Typography component="p">
                    {ByIdDetails?.pinCode || "-"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <Box>
                  <Typography component="h5">{t.main.address}</Typography>
                  <Typography component="p">
                    {ByIdDetails?.address || "-"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <Box>
                  <Typography component="h5">{t.main.accountStatus}</Typography>
                  <Typography component="p">
                    {ByIdDetails?.isBlocked === false ? "Active" : "Active"}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
      <ImageModal open={open} handleClose={handleClose} image={selectedImage} />
    </Card>
  );
};

export default CustomerDetails;
